export default "__VITE_ASSET__I19AbZgl__"